import axios from 'axios';
import { getTokenSilently } from '../react-auth0-spa';

const apiUrl =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_PROD_API_URL
    : process.env.REACT_APP_DEV_API_URL;

const getToken = async () => {
  const token = await getTokenSilently();
  if (process.env.NODE_ENV !== 'production') {
    console.log(token);
  }

  return {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  };
};

const createCompany = async (body) => {
  return await axios.post(
    `${apiUrl}/api/company/create`,
    body,
    await getToken()
  );
};

const getAllProjectsForAdmin = async () => {
  return await axios.get(`${apiUrl}/api/project/admin`, await getToken());
};

const getAllUsersForAdmin = async () => {
  return await axios.get(`${apiUrl}/api/user/allUsers`, await getToken());
};

const getAllUsersInStageForAdmin = async (stageId) => {
  return await axios.get(
    `${apiUrl}/api/user/in-stage?stageId=${stageId}`,
    await getToken()
  );
};

const getAllUsersNotInStageForAdmin = async (stageId) => {
  return await axios.get(
    `${apiUrl}/api/user/not-in-stage?stageId=${stageId}`,
    await getToken()
  );
};

const deleteUserFromStage = async (body) => {
  return await axios.post(
    `${apiUrl}/api/user/remove-from-stage`,
    body,
    await getToken()
  );
};

const deleteSelfUserFromStage = async (body) => {
  return await axios.post(
    `${apiUrl}/api/user/remove-self-from-stage`,
    body,
    await getToken()
  );
};

const addUserToStage = async (body) => {
  return await axios.post(
    `${apiUrl}/api/user/add-to-stage`,
    body,
    await getToken()
  );
};

const addSelfUserToStage = async (body) => {
  return await axios.post(
    `${apiUrl}/api/user/add-self-to-stage`,
    body,
    await getToken()
  );
};

const getAllProjectData = async (id) => {
  return await axios.get(`${apiUrl}/api/project?id=${id}`, await getToken());
};

const postProjectData = async (body) => {
  return await axios.post(`${apiUrl}/api/project`, body, await getToken());
};

const postStageData = async (body) => {
  return await axios.post(`${apiUrl}/api/stage`, body, await getToken());
};

const deleteStage = async (body) => {
  return await axios.post(`${apiUrl}/api/stage/delete`, body, await getToken());
};

const deleteProject = async (body) => {
  return await axios.post(
    `${apiUrl}/api/project/delete`,
    body,
    await getToken()
  );
};

const postProjectNote = async (body) => {
  return await axios.post(`${apiUrl}/api/projectNote`, body, await getToken());
};

const postUserNote = async (body) => {
  return await axios.post(`${apiUrl}/api/userNote`, body, await getToken());
};

const getAllUserDataForAdmin = async (id) => {
  return await axios.get(`${apiUrl}/api/user?id=${id}`, await getToken());
};

const getAllUserDataForSelf = async () => {
  return await axios.get(`${apiUrl}/api/user/self/info`, await getToken());
};

const getAuthUserData = async (payload) => {
  return await axios.get(
    `${apiUrl}/api/user/auth?email=${payload}`,
    await getToken()
  );
};

const postUserData = async (body) => {
  return await axios.post(`${apiUrl}/api/user`, body, await getToken());
};

const getUserProjectTreeData = async (payload) => {
  return await axios.get(
    `${apiUrl}/api/timeLog/sumProjectAndStage?id=${payload.userId}&status=${payload.status}`,
    await getToken()
  );
};

// time sheet data for self
const getTimeSheetData = async (payload) => {
  return await axios.get(
    `${apiUrl}/api/timeLog/weekData?startDate=${payload.startDate}&endDate=${payload.endDate}`,
    await getToken()
  );
};

// time sheet data for specific user
const getTimeSheetDataOfUser = async (payload) => {
  return await axios.get(
    `${apiUrl}/api/timeLog/weekDataOfUser?startDate=${payload.startDate}&endDate=${payload.endDate}&userId=${payload.userId}`,
    await getToken()
  );
};

const saveTimeLog = async (body) => {
  return await axios.post(`${apiUrl}/api/timeLog`, body, await getToken());
};

const saveOvertime = async (body) => {
  return await axios.post(
    `${apiUrl}/api/timeLog/overtime`,
    body.data,
    await getToken()
  );
};

const getAllIncomeExpense = async (payload) => {
  return await axios.get(
    `${apiUrl}/api/incomeExpense?stageId=${payload}`,
    await getToken()
  );
};

const deleteIncomeExpenseEntry = async (body) => {
  return await axios.post(
    `${apiUrl}/api/incomeExpense/delete`,
    body,
    await getToken()
  );
};

const addIncomeExpenseEntry = async (body) => {
  return await axios.post(
    `${apiUrl}/api/incomeExpense`,
    body,
    await getToken()
  );
};

const getIncomeExpenseBalance = async (body) => {
  return await axios.get(
    `${apiUrl}/api/incomeExpense/sum?stageId=${body}`,
    await getToken()
  );
};

const getCalendarData = async (body) => {
  return await axios.get(
    `${apiUrl}/api/offTimeLog/calendar?date=${body}`,
    await getToken()
  );
};

const getMonthReport = async (body) => {
  const { headers } = await getToken();
  const config = {
    responseType: 'blob',
    timeout: 30000,
    headers,
  };
  return await axios.get(`${apiUrl}/api/reports/month?date=${body}`, config);
};

const getCustomReport = async (body) => {
  const { headers } = await getToken();
  const config = {
    responseType: 'blob',
    timeout: 30000,
    headers,
  };
  return await axios.get(`${apiUrl}/api/reports/custom?date=${body}`, config);
};

const getAllActivities = async () => {
  return await axios.get(`${apiUrl}/api/activity/all`, await getToken());
};

const getAllActivityData = async (id) => {
  return await axios.get(`${apiUrl}/api/activity?id=${id}`, await getToken());
};

const postActivityData = async (body) => {
  return await axios.post(`${apiUrl}/api/activity`, body, await getToken());
};

const deleteActivity = async (body) => {
  return await axios.post(
    `${apiUrl}/api/activity/delete`,
    body,
    await getToken()
  );
};

const getAllUsersInActivityForAdmin = async (activityId) => {
  return await axios.get(
    `${apiUrl}/api/user/in-activity?activityId=${activityId}`,
    await getToken()
  );
};

const getAllUsersNotInActivityForAdmin = async (activityId) => {
  return await axios.get(
    `${apiUrl}/api/user/not-in-activity?activityId=${activityId}`,
    await getToken()
  );
};

const deleteUserFromActivity = async (body) => {
  return await axios.post(
    `${apiUrl}/api/user/remove-from-activity`,
    body,
    await getToken()
  );
};

const addUserToActivity = async (body) => {
  return await axios.post(
    `${apiUrl}/api/user/add-to-activity`,
    body,
    await getToken()
  );
};

const getUserActivitiesData = async (payload) => {
  return await axios.get(
    `${apiUrl}/api/activityLog/sumActivity?id=${payload.userId}`,
    await getToken()
  );
};

const getHolidayInfo = async () => {
  return await axios.get(`${apiUrl}/api/holidayInfo`, await getToken());
};

const getSelfStats = async () => {
  return await axios.get(`${apiUrl}/api/user/self/stats`, await getToken());
};

const getAllUsersStats = async (date) => {
  return await axios.get(
    `${apiUrl}/api/user/all/stats?date=${date}`,
    await getToken()
  );
};

const postClaim = async (values) => {
  return await axios.post(`${apiUrl}/api/claimLog`, values, await getToken());
};

const getSelfClaims = async () => {
  return await axios.get(`${apiUrl}/api/claimLog/self`, await getToken());
};

const getUserClaims = async (userId) => {
  return await axios.get(
    `${apiUrl}/api/claimLog/user?userId=${userId}`,
    await getToken()
  );
};

const deleteClaim = async (body) => {
  return await axios.post(
    `${apiUrl}/api/claimLog/delete`,
    body,
    await getToken()
  );
};

const changeClaimStatus = async (body) => {
  return await axios.post(
    `${apiUrl}/api/claimLog/change`,
    body,
    await getToken()
  );
};

const closeWeek = async (body) => {
  return await axios.post(
    `${apiUrl}/api/user/close-week`,
    body,
    await getToken()
  );
};

const getStageStats = async (body) => {
  return await axios.get(
    `${apiUrl}/api/stage/stats?id=${body}`,
    await getToken()
  );
};

const getProjectStats = async (body) => {
  return await axios.get(
    `${apiUrl}/api/project/stats?id=${body}`,
    await getToken()
  );
};

const getActivityStats = async (body) => {
  return await axios.get(
    `${apiUrl}/api/activity/stats?id=${body}`,
    await getToken()
  );
};

const api = {
  createCompany,
  getAllProjectsForAdmin,
  getAllUsersForAdmin,
  getAllUsersInStageForAdmin,
  getAllUsersNotInStageForAdmin,
  deleteUserFromStage,
  deleteSelfUserFromStage,
  addUserToStage,
  addSelfUserToStage,
  getAllProjectData,
  postProjectData,
  postStageData,
  deleteStage,
  deleteProject,
  postProjectNote,
  postUserNote,
  getAllUserDataForAdmin,
  getAllUserDataForSelf,
  getAuthUserData,
  postUserData,
  getUserProjectTreeData,
  getTimeSheetData,
  getTimeSheetDataOfUser,
  saveTimeLog,
  getAllIncomeExpense,
  deleteIncomeExpenseEntry,
  addIncomeExpenseEntry,
  getIncomeExpenseBalance,
  getCalendarData,
  getMonthReport,
  getCustomReport,
  getAllActivities,
  getAllActivityData,
  postActivityData,
  deleteActivity,
  getAllUsersInActivityForAdmin,
  getAllUsersNotInActivityForAdmin,
  deleteUserFromActivity,
  addUserToActivity,
  getUserActivitiesData,
  getHolidayInfo,
  saveOvertime,
  getSelfStats,
  getAllUsersStats,
  postClaim,
  getSelfClaims,
  deleteClaim,
  getUserClaims,
  changeClaimStatus,
  closeWeek,
  getStageStats,
  getProjectStats,
  getActivityStats,
};

export default api;
